import { IPayAtVenue } from "~/types/api-types";
import { LISTING_PAY_AT_VENUE_TYPE_MINIMUM_SPEND_DEPOSIT } from "~/utils/constants";

/**
 * Whether listing pay-at-venue configuration is the minimum-spend deposit flow
 * (deposit listing copy on the LP and elsewhere).
 */
export const isMinimumSpendDepositListing = (
  payAtVenue?: IPayAtVenue | null,
): boolean =>
  payAtVenue?.type === LISTING_PAY_AT_VENUE_TYPE_MINIMUM_SPEND_DEPOSIT;
